/**
 * #1307: один OAuth-код Яндекса обменивается не более одного раза за сессию браузера/WebView.
 * Повторная доставка (обновление страницы, «назад», повтор Android-intent, перемонтирование
 * шлюза) иначе шлёт уже потреблённый код и получает invalid_grant.
 */

const KEY = "yandexExchangedCodes";
const MAX_REMEMBERED = 20;

type StorageLike = Pick<Storage, "getItem" | "setItem">;

/** Короткий необратимый хэш (cyrb53): сам код в хранилище не кладём. */
function hashCode(code: string): string {
    let h1 = 0xdeadbeef;
    let h2 = 0x41c6ce57;
    for (let i = 0; i < code.length; i++) {
        const ch = code.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
    return (4294967296 * (2097151 & h2) + (h1 >>> 0)).toString(36);
}

function readList(storage: StorageLike): string[] {
    try {
        const parsed = JSON.parse(storage.getItem(KEY) || "[]");
        return Array.isArray(parsed) ? parsed.filter((x): x is string => typeof x === "string") : [];
    } catch {
        return [];
    }
}

/**
 * Помечает код обменянным. true — код новый, можно слать на бэкенд;
 * false — этот код уже уходил на обмен. Сбой хранилища не бросает: тогда считаем код новым.
 */
export function claimOauthCode(storage: StorageLike | null | undefined, code: string): boolean {
    if (!storage) return true;
    try {
        const hash = hashCode(code);
        const list = readList(storage);
        if (list.includes(hash)) return false;
        storage.setItem(KEY, JSON.stringify([...list, hash].slice(-MAX_REMEMBERED)));
        return true;
    } catch {
        return true;
    }
}
